module.exports = __webpack_public_path__ + "static/media/close-button.82f06dea.svg";